import React, { Fragment } from 'react';
import { isEmpty } from 'lodash';

import { ICONS } from 'Components/utils/icon/icons';
import { Heading } from 'Components/frameworks/heading/Heading';
import { SimpleNotification } from 'Components/frameworks/notification/SimpleNotification';

import { t } from 'Src/i18n';

import { PersonInfo } from './contact-info-form/PersonInfo';

const AttendeeBlock = ({
  attendee,
  attendeeIndexInList,
  i18n,
  connectedUserInfo,
  hasMainAttendeeErrors,
  hasPerformValidation,
  hasAddress,
  arrivalDate,
}) => {
  const { id, isMain = false, isChild = false, attendeeIndex } = attendee;
  const listIdentifier = isChild ? 'children' : 'adults';
  const attendeeIdentifier = `${listIdentifier}.${attendeeIndex}`;

  return (
    <div className="mt-20" key={attendeeIdentifier}>
      <PersonInfo
        attendeeIdentifier={attendeeIdentifier}
        listIdentifier={listIdentifier}
        attendeeIndex={attendeeIndex}
        connectedUserInfo={connectedUserInfo}
        hasMainAttendeeErrors={hasMainAttendeeErrors}
        hasPerformValidation={hasPerformValidation}
        hasAddress={hasAddress}
        i18n={i18n}
        id={id}
        isChild={isChild}
        isMain={isMain}
        arrivalDate={arrivalDate}
        parentIndex={attendeeIndexInList}
        isUserConnected={!isEmpty(connectedUserInfo)}
      />
    </div>
  );
};

const AttendeesForms = ({
  list,
  arrivalDate,
  connectedUserInfo,
  hasMainAttendeeErrors,
  hasPerformValidation,
  hasAddress,
  i18n,
}) => {
  return (
    <div className="my-20">
      {list.map((attendee, attendeeIndexInList) => (
        <div key={attendee.id}>
          <AttendeeBlock
            attendee={{
              gmNumber: attendee.gmNumber,
              id: attendee.id,
              isMain: attendee.isMain,
              isChild: !attendee.isAdult,
              attendeeIndex: attendee.attendeeIndex,
            }}
            attendeeIndexInList={attendeeIndexInList}
            arrivalDate={arrivalDate}
            connectedUserInfo={connectedUserInfo}
            hasMainAttendeeErrors={hasMainAttendeeErrors}
            hasPerformValidation={hasPerformValidation}
            hasAddress={hasAddress}
            i18n={i18n}
          />
          {attendeeIndexInList === 0 && list.length > 1 && !isEmpty(connectedUserInfo) && (
            <Fragment>
              <Heading className="mb-20 mt-40" hLevel={3} theme="heading-brand-1">
                {t('booking.participants.travelCompanions')}
              </Heading>
              <SimpleNotification
                id="ContactInfoFormInformations"
                title={t('booking.participants.personnalInfosHeader.identityPapersMatchingTitle')}
                content={t('booking.participants.personnalInfosHeader.identityPapersMatching')}
                iconName={ICONS.EXCLAMATION_POINT}
              />
            </Fragment>
          )}
        </div>
      ))}
    </div>
  );
};

export default AttendeesForms;
